import Button from "../reusable/Button";
import Navigator from "./Navigator";
import plus from "../../assets/plus.svg";

export default function PageLayout({
    title,
    description,
    buttonTitle,
    buttonWidth,
    children,
    BreadcrumbsUrl,
    setAddTripModal,
    paddingRight,


}) {

    return (
        <Navigator
            BreadcrumbsUrl={BreadcrumbsUrl}
        >
            <div className="flex flex-col w-full h-full pt-3">
                <div className="flex justify-between w-full">
                    {title && (
                        <div>
                            <h3 className="pt-3  text-lg lg:text-2xl font-semibold">{title}</h3>
                            <h3 className="pt-1 text-placeholder-gray whitespace-nowrap">{description}</h3>
                        </div>
                    )}
                    <div>
                        {buttonTitle && (
                            <div className="  mr-0 lg:mr-1 lg:mt-0 mt-3">
                                <Button
                                    onClick={() => {
                                        setAddTripModal(true);

                                    }}
                                    text={buttonTitle}
                                    width={buttonWidth}
                                    icon={plus}
                                    paddingRight={paddingRight}
                                />
                            </div>

                        )}
                    </div>
                </div>
                <div className="h-full overflow-y-auto">{children}</div>
            </div>
        </Navigator>
    );
}